'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    SKILLNAMES: {
        1: 'Verkeer',
        2: 'Woon',
        3: 'Aansprakelijkheid',
        4: 'Reis',
        5: 'Sales',
        6: 'SalesBeeindiging',
        7: 'Sparen',
        8: 'DIL',
        9: 'HYP',
        10: 'LevenNieuw'
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/waiting-time/waiting-time.constants.js
// module id = 928
// module chunks = 0